import { Component, h } from 'preact';

class TcrPercentInput extends Component
{
    constructor(props)
    {
        super(props);

        this.validateInput = this.validateInput.bind(this);
        this.formatValue = this.formatValue.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.state = {
            value: '0,00 %'
        };
    }

    validateInput(event)
    {
        let rawvalue = event.target.value;

        let value = rawvalue.replace(/[^0-9,]/g, '');
        value = value.replace(/,/g, '.');

        value = parseFloat(value || 0) / 100.0;

        this.setState({
            value: rawvalue
        }, () => {
            this.props.onInput({
                target: {
                    value: value,
                    dataset: {
                        field: this.props.field
                    }
                }
            });
        });
    }

    onFocus()
    {
        let value = typeof this.props.value === 'undefined' ? '0.00' : this.props.value;
        value = value.replace(/[^0-9\.]/g, '');
        value = parseFloat(value);
        
        let formatter = new Intl.NumberFormat('de-DE', {style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });

        console.log('onFocus', this.props.value, formatter.format(value).slice(0, -2).replace('.', ''));
        this.setState({
            value: formatter.format(value).slice(0, -2).replace('.', ''),
            focus: true
        });
    }

    onBlur()
    {
        this.setState({
            focus: false
        });
    }

    formatValue()
    {
        if (this.state.focus)
        {
            return this.state.value;
        }
        else
        {
            let formatter = new Intl.NumberFormat('de-DE', {style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2});
            return formatter.format(parseFloat(this.props.value) || 0);
        }
    }

    render()
    {
        return <input type="text" value={this.formatValue()} data-field={this.props.field} onInput={this.validateInput} onFocus={this.onFocus} onBlur={this.onBlur} />;
    }
}

export { TcrPercentInput };